import { Navigate, useLocation } from 'react-router-dom';
import { stripSlot } from '../lib/accountSlot';

/**
 * A `/u/...` path the router didn't consume as this tab's basename. Slot 0
 * has no prefix, so `/u/0/<path>` keeps its path (and query/hash) without
 * it; any other `/u/N` is not a valid account slot and goes home.
 */
export function SlotPathRedirect() {
  const { pathname, search, hash } = useLocation();
  if (!/^\/u\/0(?=\/|$)/.test(pathname)) return <Navigate to="/" replace />;
  return <Navigate to={`${stripSlot(pathname)}${search}${hash}`} replace />;
}
